//---- components ---------
//---- mixins -------------
//---- services -----------
import AuthoringService from '../services/authoring.service.js';
//---- other --------------
//---- 3rd-parties --------

export const initialState = {
    caseData: '',           // original content of the case being authored
    authoringData: '',      // content of the case being authored
    dirtyAttributes: [],    // array indicating which attributes were modified
    validationErrors: []
}

export const authoring = {
    namespaced: true,

    state: { ...initialState },

    actions: {
        solutionView({ commit }, id) {
            return AuthoringService.solutionView(id).then(response =>
                commit('setCaseData', response.data))
        },

        authoring({ commit }) {
            return AuthoringService.authoring().then(response => {
                if (response) commit('setAuthoringData', response.data);
                return Promise.resolve(response)
            })
        },

        authoringMCM({ commit }) {
            return AuthoringService.authoringMCM().then(response => {
                if (response) commit('setAuthoringData', response.data);
                return Promise.resolve(response)
            })
        },

        updateDirtyAttributes({ commit }, attributeValue) {
            commit('updateDirtyAttributes', attributeValue);
        },

        removeDirtyAttribute({ commit }, slotId) {
            commit('removeDirtyAttribute', slotId);
        },

        initializeDirtyAttributes({ commit }) {
            commit('initializeDirtyAttributesData');
            return true;
        },

        setValidationErrors({ commit }, errorInfo) {
            commit('setValidationErrors', errorInfo);
            return true;
        },
        removeValidationErrors({ commit }, slotId) {
            commit('removeValidationErrors', slotId);
            return true;
        },
    },

    mutations: {
        setCaseData(state, caseData) {
            state.caseData = caseData;
        },
        setAuthoringData(state, authoringData) {
            state.authoringData = authoringData;
        },
        initializeDirtyAttributesData(state) {
            state.dirtyAttributes = [];
        },
        updateDirtyAttributes(state, attributeValue) {
            // remove the prior value if any
            const slotId = attributeValue.slotId;
            var i = state.dirtyAttributes.length;
            while (i--) {
                if (state.dirtyAttributes[i]?.slotId === slotId) {
                    state.dirtyAttributes.splice(i, 1);
                }
            }

            // add the new value
            state.dirtyAttributes = [...state.dirtyAttributes, attributeValue]
        },
        // remove the dirty attribute
        removeDirtyAttribute(state, slotId) {
            var i = state.dirtyAttributes.length;
            while (i--) {
                if (state.dirtyAttributes[i]?.slotId === slotId) {
                    state.dirtyAttributes.splice(i, 1);
                }
            }

            // update the dirty attributes after deletion
            state.dirtyAttributes = [...state.dirtyAttributes]
        },
        setValidationErrors(state, errorInfo) {
            // remove the prior value if any
            const slotId = errorInfo.slotId;
            var i = state.validationErrors.length;
            while (i--) {
                if (state.validationErrors[i]?.slotId === slotId) {
                    state.validationErrors.splice(i, 1);
                }
            }

            // add the new value
            state.validationErrors = [...state.validationErrors, errorInfo]
        },
        removeValidationErrors(state, slotId) {
            var i = state.validationErrors.length;
            while (i--) {
                if (state.validationErrors[i]?.slotId === slotId) {
                    state.validationErrors.splice(i, 1);
                }
            }
            // update the validation errors after
            state.validationErrors = [...state.validationErrors]
        }
    },
}